import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
} from '@mui/material';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';

// Shows the validation issues returned by a failed (422) flow activation.
export default function ActivationIssuesDialog({ open, issues, onClose }) {
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth='sm'>
      <DialogTitle>Flow kann nicht aktiviert werden</DialogTitle>
      <DialogContent>
        <Typography variant='body2' color='text.secondary' sx={{ mb: 1 }}>
          Bitte behebe die folgenden Punkte und versuche es danach erneut:
        </Typography>
        <List dense disablePadding>
          {(issues || []).map((issue, index) => (
            <ListItem key={issue.code || index} disableGutters>
              <ListItemIcon sx={{ minWidth: 32 }}>
                <ErrorOutlineIcon color='error' fontSize='small' />
              </ListItemIcon>
              <ListItemText
                primary={issue.message || issue.msg || String(issue)}
                secondary={issue.code}
              />
            </ListItem>
          ))}
        </List>
      </DialogContent>
      <DialogActions>
        <Button variant='contained' onClick={onClose}>
          Schließen
        </Button>
      </DialogActions>
    </Dialog>
  );
}
